module.exports = __webpack_public_path__ + "static/media/mustard.c6b28a81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/mustard.svg
// module id = 1128
// module chunks = 0